import { Breadcrumb, ConfigProvider } from 'antd';
import React, { useMemo } from 'react';
import { map } from 'underscore';
import { Link } from '../link/link';
import classNames from 'classnames';
import { findPath } from '../../functions/breadcrumbs';
import { connect } from 'react-redux';
import { useState } from 'react';
import { BreadcrumbCustom } from './breadcrumbCustom';

export const Breadcrumbs = connect((state) => ({
    types: state.shopState.types,
    setting: state.appState.setting,
}))(
    ({
        showOne,
        typeId,
        types,
        dispatch,
        onLink,
        className,
        setting,
        ...rest
    }) => {
        const breadcrumbs = useMemo(() => {
            if (types.isNotReady) return [];
            return findPath(types.response.lists, Number(typeId));
        }, [typeId, types]);

        return showOne || breadcrumbs?.length > 1 ? (
            <Breadcrumb
                style={{
                    '--separator-color':
                        setting.content.breadcrumbs.main.commonColor,
                    '--separator-color-hover':
                        setting.content.breadcrumbs.main.commonHoverColor,
                }}
                className={classNames('shop-breadcrumbs', className)}
                items={map(breadcrumbs, ({ id, name }) => {
                    return {
                        title: (
                            <BreadcrumbCustom
                                name={name}
                                id={id}
                                typeId={typeId}
                                setting={setting}
                                onLink={onLink}
                            />
                        ),
                        className: 'test',
                        key: name,
                    };
                })}
                {...rest}
            />
        ) : null;
    }
);
